class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      this.onClick(event)
    });
  }

  async onClick(event) {
    event.preventDefault();
    const {
      childProductId
    } = event.target.dataset
    await this.closest('cart-items').updateQuantity(this.dataset.index, 0, !childProductId);

    if (!!childProductId) {
      const elSelectChildProduct = document.querySelector(`select[data-parent-product-id="${childProductId}"]`)
      if (elSelectChildProduct) {
        const {
          index
        } = elSelectChildProduct.dataset
        await document.querySelectorAll('cart-items')[0].updateQuantity(index, 0, document.activeElement.getAttribute('name'));
      }
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.isMiniCart = !!this.dataset.isMiniCart;
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      if (event.target.type === 'checkbox') return false
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // CUSTOMER_ID is defined is theme.liquid
    // CUSTOMER_ID retourne l'id du customer, sinon retourne une chaine vide ''.
    if (window.CUSTOMER_ID == '') {

      const parentLineItems = document.querySelectorAll('.c-line-item');

      // Je boucle sur l'élément qui contient les lines items

      parentLineItems.forEach((lineItem, index) => {
        // si lineItem a un data-attribut data-vp, c'est que c'est un produit Vente Privée, donc on rentre dans la condition.  

        if (lineItem.dataset.vp != undefined) {
          this.updateQuantity(index + 1, 0, 'updates[]', true);
          //  setTimeout(() => {
          //  }, index*2000);

        }
      });
    }
  }




  async onChange(event) {
    const {
      childProductId
    } = event.target.dataset
    await this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), !childProductId);
    if (!!childProductId) {
      const elSelectChildProduct = document.querySelector(`select[data-parent-product-id="${childProductId}"]`)
      if (elSelectChildProduct) {
        const {
          index
        } = elSelectChildProduct.dataset
        await this.updateQuantity(index, event.target.value, document.activeElement.getAttribute('name'));
      }
    }
  }

  getSectionsToRender() {
    return [{
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.js-contents'
      },
      {
        id: 'main-cart-footer',
        section: !!document.getElementById('main-cart-footer') ? document.getElementById('main-cart-footer').dataset.id : false,
        selector: '.js-contents'
      }
    ];
  }

  async updateQuantity(line, quantity, name, isRender = true) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateLiveRegions(line, parsedState.item_count);
        if (isRender) {
          this.renderContents(parsedState)
          this.disableLoading();
        }

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        if (!!document.getElementById('cart-errors')) document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  renderContents(parsedState) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');
    const cartMsg = document.getElementById('cart-msg');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartMsg) cartMsg.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      if (!!section.section) {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
    }));

    if (this.isMiniCart) {
      const miniCartHtml = parsedState.sections['mini-cart'];
      this.updateMiniCart(miniCartHtml);
    }

    if (!this.isMiniCart) {
      const footerSection = this.getSectionsToRender().filter(section => section.id === 'main-cart-footer');
      if (footerSection.length) {
        this.updateProgressBar(parsedState.sections[footerSection[0].section]);
        this.updateShippingsMethod(parsedState.sections[footerSection[0].section]);
      }
    }

    if (parsedState.item_count === 0) {
      sessionStorage.setItem('giftAdded', 'false');
    }
  }

  updateShippingsMethod(html) {
    const newDOM = new DOMParser().parseFromString(html, 'text/html');
    const elShippingMethod = document.querySelector('#cart-shipping-methods');
    const newShippingMethod = newDOM.querySelector('#cart-shipping-methods');
    if (!!elShippingMethod && newShippingMethod) {
      elShippingMethod.innerHTML = newShippingMethod.innerHTML
    }
  }

  updateProgressBar(html) {
    const newDOM = new DOMParser().parseFromString(html, 'text/html');
    const elProgressBar = document.querySelector('#cart-free-shipping');
    const newProgressBar = newDOM.querySelector('#cart-free-shipping');

    if (!!elProgressBar && newProgressBar) {
      elProgressBar.innerHTML = newProgressBar.innerHTML
    }
  }

  updateMiniCart(html) {
    const newDOM = new DOMParser()
      .parseFromString(html, 'text/html');
    const elMiniCartFooter = this.querySelector('#mini-cart-footer');
    const newFooter = newDOM.querySelector('#mini-cart-footer');

    if (!!elMiniCartFooter && newFooter) {
      elMiniCartFooter.innerHTML = newFooter.innerHTML
    }
    const elMiniCartHeader = this.querySelector('#mini-cart-header');
    const newHeader = newDOM.querySelector('#mini-cart-header');

    if (!!elMiniCartHeader && newHeader) {
      elMiniCartHeader.innerHTML = newHeader.innerHTML
    }
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const loader = this.querySelector('.loading-overlay__spinner') || document.querySelector('.loading-overlay__spinner');
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
    if (loader) loader.classList.remove('hidden')
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    const loader = this.querySelector('.loading-overlay__spinner') || document.querySelector('.loading-overlay__spinner');
    if (loader) loader.classList.add('hidden')
  }
}

customElements.define('cart-items', CartItems);

class CartGift extends HTMLElement {
  constructor() {
    super();
    this.addGift = this.querySelector('[data-js-add-gift]');

    if (this.addGift) {
      this.addGiftToCart();
    } else {
      console.log('Gift element not found');
    }
  }

  async addGiftToCart() {
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    if (sessionStorage.getItem('giftAdded') === 'true') {
      return;
    }

    // Prepare the body of the request to add the gift product to the cart
    let body = JSON.stringify({
      items: [{
        id: this.addGift.dataset.productId,
        quantity: 1,
        properties: {
          '_gift': true
        }
      }],
      sections: cartItems ? cartItems.getSectionsToRender().map((section) => section.section) : [],
      sections_url: window.location.pathname
    });

    // Send a request to add the gift product to the cart
    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      });

      if (response.ok) {
        const state = await response.json();

        // Re-render minicart contents after the item is added
        if (cartItems) {
          cartItems.renderContents(state);
        }

        sessionStorage.setItem('giftAdded', 'true');
      } else {
        console.error('Failed to add gift to cart', response.statusText);
      }
    } catch (error) {
      console.error('Error adding gift to cart:', error);
    }
  }
}

customElements.define('cart-gift', CartGift);